import { render } from "./InterfaceMenu.vue?vue&type=template&id=df2a8666"
import script from "./InterfaceMenu.vue?vue&type=script&lang=js"
export * from "./InterfaceMenu.vue?vue&type=script&lang=js"

import "./InterfaceMenu.vue?vue&type=style&index=0&id=df2a8666&lang=scss"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__